import { render, staticRenderFns } from "./SubjectDetailView.vue?vue&type=template&id=f9d588b0&"
import script from "./SubjectDetailView.ts?vue&type=script&lang=js&"
export * from "./SubjectDetailView.ts?vue&type=script&lang=js&"
import style0 from "./SubjectDetailView.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports